









































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';

    class EditUserExpressInfo {
        id: number;
        shipment: string;
        reMark: string;
        whetherHandle: boolean;
        userUploadImageGuid: string;
    }
    @Component
    export default class EditUserExpressInfoModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        isReadOnly = false;
        imgUrl: string = '';
        imgUploadUrl: string = '';
        orderNumber: string = "";
        EditModule: EditUserExpressInfo = new EditUserExpressInfo();
        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };

        created() {
            this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/UserExpressInfo/UploadUserExpressImg";
        }
        cancel() {
            (this.$refs.userexpressinfoForm as any).resetFields();
            this.$emit('input', false);
        }
        save() {
            (this.$refs.userexpressinfoForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.$store.dispatch({
                        type: 'expressuserinfo/updateremark',
                        data: this.EditModule
                    });
                    (this.$refs.userexpressinfoForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }

        handleSuccess(res, file) {
            if (res.success) {
                this.EditModule.userUploadImageGuid = res.result;
                this.setImage();
            }
        }


        handleError(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }

        setImage() {
            if (this.EditModule.userUploadImageGuid && this.EditModule.userUploadImageGuid.length > 1) {
                var data = { imageGuid: this.EditModule.userUploadImageGuid, url: null };
                this.$store.commit('expressuserinfo/getImgUrl', data);
                this.imgUrl = data.url;
            } else {
                this.imgUrl = null;
            }
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                (this.$refs.userexpressinfoForm as any).resetFields();
                this.isReadOnly = false;
                var data = this.$store.state.expressuserinfo.userExpressInfo;
                this.EditModule.shipment = data.shipment;
                this.EditModule.whetherHandle = data.whetherHandle;
                this.EditModule.userUploadImageGuid = data.userUploadImageGuid;
                this.EditModule.id = data.id;
                this.orderNumber = data.orderNumber;
                this.setImage();
                if (data.shipment && data.shipment.length > 1) {
                    this.isReadOnly = true;
                }
            }
        }
    }

